import { jsx as o } from "react/jsx-runtime";
import t from "../base-button.mjs";
const n = (r) => /* @__PURE__ */ o(
  t,
  {
    color: "text-text-primary",
    hoverColor: "hover:text-background-secondary",
    backgroundColor: "bg-transparent",
    hoverBackgroundColor: "hover:bg-text-primary",
    borderColor: "border-text-primary",
    loaderType: "dark",
    ...r
  }
);
export {
  n as SecondaryButton
};
